<template>
    <Modal @update:show="cancel">
        <div class="flex">
            <img :src="'media/doc/attention2.png'" width="30" />
            <h3 class="ml-4 text-xl leading-6 font-medium text-white">
                {{ title }}
            </h3>
        </div>
        <div class="flex mt-4">
            <div class="ml-4 text-gray-200" v-html="message"></div>
        </div>
        <div class="mt-7 w-full flex justify-between">
            <form-button class="w-40 py-2" @click="confirm" color='danger'>Confirm</form-button>
            <form-button class="w-40 py-2" @click="cancel">Cancel</form-button>
        </div>
    </Modal>
</template>

<script>

import Modal from './Modal.vue';

export default {
    name: "ConfirmationModal",
    components: {
        Modal,
    },
    props: {
        title: {
            type: String,
            default: "Please Attention"
        },
        message: {
            type: String,
            default: 'Are you sure?'
        }
    },
    emits: ['confirm', 'cancel'],
    methods: {
        confirm() {
            this.$emit('confirm');
        },
        cancel() {
            this.$emit('cancel');
        },
    },

};
</script>

<style scoped>
/* Styles for modal and close button */
</style>